import { useEffect, useState } from "react";

const useForm = (callback, validate, getDefaultValues, reloadKey) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (getDefaultValues) {
      const defaultValues = getDefaultValues();
      setValues(defaultValues);
    }
  }, [reloadKey]);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback(values);
    }
  }, [errors]);

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    const validationErrors = validate(values);
    setErrors(validationErrors);
    setIsSubmitting(true);
  };

  const handleChange = (event, query) => {
    if (query) {
      setValues((prevValues) => ({
        ...prevValues,
        ...query,
      }));
      return;
    }
    event?.persist?.();
    setValues((prevValues) => ({
      ...prevValues,
      [event?.target?.name]: event?.target?.value,
    }));
  };

  const handleSubmitSuccess = (newValues) => {
    setValues(newValues);
  };

  return {
    handleChange,
    handleSubmit,
    handleSubmitSuccess,
    values,
    errors,
  };
};

export default useForm;
